module.exports = __webpack_public_path__ + "img/irish-dress.94028a5f.jpeg";